import { exeRequest } from '../utils/APIUtils'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getPartenairesRecent: async () => exeRequest(`/admin//dashboard/partenaires/recent`, "GET"),
    getPartenaireInscriptionParJour: async (data) => exeRequest(`/admin/dashboard/partenaires/inscriptions-per-day`, "GET"),
    getPartenaireYandex: async (data) => exeRequest(`/admin/dashboard/yandex/partenaires`, "GET"),
    getPartenairesThisWeekWithVehicle: async (data) => exeRequest(`/admin/dashboard/partenaires/this-week/with-vehicle`, "GET"),
    getPartenairesThisWeekWithoutVehicle: async (data) => exeRequest(`/admin/dashboard/partenaires/this-week/without-vehicle`, "GET"),
    getOperationStats: async (data) => exeRequest(`/admin/dashboard/operations/stats`, "GET"),
    getYandexVsTigoon: async (data) => exeRequest(`/admin/dashboard/sync/yandex-vs-tigoon`, "GET"),
    getOperationsStats: async (periode = 'jour', opts = {}) => exeRequest(`/admin/dashboard/operations/stats?periode=${periode}${opts.detail ? '&detail=true' : ''}`, 'GET'),
    listAllOperations: async (params = {}) => exeRequest(`/admin/dashboard/operations/list${buildQuery(params)}`, "GET"),
}

// petit helper pour sérialiser les params
function buildQuery(params) {
  const q = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return q ? `?${q}` : '';
}